module.exports = __webpack_public_path__ + "img/logo_kt_round.bcf19fb7.svg";